import { Space } from "antd";
import { observer } from "mobx-react-lite";
import EmployeeAttendanceCard from "./cards/EmployeeAttendanceCard";
// import UploadBtn from "./buttons/UploadBtn";
import FilterBtn from "./buttons/FilterBtn";
import ViewAll from "./buttons/ViewAll";
import { useAttendance } from "../../../app/hooks/useAttendance";
import { useStore } from "../../../app/stores/store";

const AttendanceGallery = () => {
  const { attendaceStore } = useStore();
  const { startDate, endDate } = attendaceStore;

  const { data } = useAttendance({
    pageNumber: 0,
    pageSize: 3,
    startDate: startDate ?? "",
    endDate: endDate ?? "",
    sort: "date_descend",
  });

  return (
    <div className="attendance-gallery-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "20px",
        }}
      >
        <h3>Attendance Gallery</h3>
        <Space>
          {/* <UploadBtn /> */}
          <FilterBtn />
        </Space>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <EmployeeAttendanceCard />
        {data && data.length > 0 && <ViewAll />}
      </div>
    </div>
  );
};

export default observer(AttendanceGallery);
